import styled from 'styled-components';

export const ManageContainer = styled.div`
width: 100%;
height: 100%;
background: #F0FFE6;
position: relative;
`;

export const ManageWrapper = styled.div`
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 50px 25px;
`;

export const ManageHeader = styled.h3`
font-size: 24px;
color: #000;
padding: 10px 20px;
`;

export const AddButton = styled.button`
display: flex;
align-items: center;
width: fit-content;
height: fit-content;
padding: 5px 10px;
border-radius: 5px;
border: none;
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
font-size: 18px;
margin-left: 20px;
margin-top: 10px;
margin-bottom: 10px;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.02);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}
`;

export const MemberContainer = styled.div`
width: 100%;
position: relative;
background: #fff;
border-radius: 10px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
margin-bottom : 25px;
padding: 15px;
`;

export const LoadingText = styled.h3`
font-size: 24px;
color: #33682c;
text-align: center;
padding: 50px;

@media screen and (max-width: 768px){
    font-size: 18px;
}

@media screen and (max-width: 480px){
    font-size: 16px;
}
`;

export const ButtonWrapper = styled.div`
display: flex;
flex-direction: row;
`;
